var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "page-outline",
    { attrs: { title: _vm.$t("Webheader.injection_annuaire") } },
    [
      _c(
        "template",
        { slot: "primaryActions" },
        [
          _c("app-button", {
            attrs: {
              text: _vm.$t("common.bck"),
              icon: "fa-light fa-arrow-left",
              variant: "primary",
            },
            on: { click: _vm.goBack },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "template",
        { slot: "pageContent" },
        [
          _c(
            "b-container",
            { attrs: { fluid: "" } },
            [
              _c(
                "form-accordion",
                {
                  attrs: {
                    toggleActive: false,
                    title: _vm.$t("annuaire.general_information"),
                    isTitleUpperCase: false,
                  },
                },
                [
                  _c(
                    "b-row",
                    {
                      staticClass:
                        "d-flex justify-content-center align-items-center",
                    },
                    [
                      _c(
                        "b-col",
                        { staticClass: "form-group", attrs: { sm: "6" } },
                        [
                          _c("form-write-group-label-input", {
                            attrs: {
                              isMandatory: "",
                              inputLabel: _vm.$t("annuaire.file_name"),
                              placeholderValue: _vm.$t("annuaire.file_name"),
                            },
                            model: {
                              value: _vm.form.name,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "name", $$v)
                              },
                              expression: "form.name",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        {
                          staticClass: "form-group d-flex flex-column",
                          attrs: { sm: "6" },
                        },
                        [
                          _c(
                            "label",
                            {
                              staticClass: "filter-item-title",
                              attrs: { for: "annuaire-file-input" },
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.$t("annuaire.annuaire_file")) +
                                  "\n              "
                              ),
                              _c("span", { staticClass: "color-red" }, [
                                _vm._v("* "),
                              ]),
                            ]
                          ),
                          _vm._v(" "),
                          _c("input", {
                            attrs: {
                              id: "annuaire-file-input",
                              type: "file",
                              accept: ".csv",
                            },
                            on: { change: _vm.handleFileUpload },
                          }),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "template",
        { slot: "bottomActions" },
        [
          _c("app-button", {
            attrs: {
              text: _vm.$t("common.sve"),
              icon: "fa-light fa-save",
              variant: "primary",
              disabled: !_vm.form.name || !_vm.base64Data,
            },
            on: { click: _vm.importTrackingFile },
          }),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }